<template>
  <b-modal
    v-model="show"
    title="Miễn nợ commission"
    size="md"
    centered
    no-close-on-backdrop
    @hidden="resetForm"
  >
    <p class="mb-2">
      Debt <strong>#{{ debtId }}</strong> — {{ voucherCode }}
    </p>
    <p class="mb-3">
      Số tiền: <strong>{{ formatAmount(amount) }}</strong>
    </p>

    <b-form-group>
      <label class="font-weight-bold mb-1">Lý do miễn nợ (≥ 10 ký tự)</label>
      <b-form-textarea
        v-model="reason"
        size="sm"
        rows="3"
        max-rows="6"
        maxlength="200"
        placeholder="VD: NV đã nghỉ việc từ 15/05/2026, không liên lạc được"
      ></b-form-textarea>
      <small v-if="reasonError" class="text-danger">{{ reasonError }}</small>
      <small class="text-muted d-block mt-1">
        Lý do sẽ lưu vào audit log (waivedReason).
      </small>
    </b-form-group>

    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        :disabled="loading"
        @click="close"
      >
        Huỷ
      </b-button>
      <b-button size="sm" variant="warning" :disabled="loading" @click="submit">
        <b-spinner v-if="loading" small class="mr-1" />
        Xác nhận miễn nợ
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { CommissionDebtService } from '@/core/services/commission-debt.service';

export default {
  name: 'WaiveDebtDialog',
  props: {
    value: Boolean,
    debtId: { type: Number, default: 0 },
    amount: { type: [Number, String], default: 0 },
    voucherCode: { type: String, default: '' },
  },
  data() {
    return {
      reason: '',
      reasonError: '',
      loading: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  methods: {
    formatAmount(n) {
      return Number(n || 0).toLocaleString('vi-VN') + ' đ';
    },
    resetForm() {
      this.reason = '';
      this.reasonError = '';
    },
    close() {
      this.show = false;
    },
    async submit() {
      const r = this.reason.trim();
      if (r.length < 10) {
        this.reasonError = 'Lý do phải ít nhất 10 ký tự';
        return;
      }
      this.reasonError = '';
      this.loading = true;
      try {
        await CommissionDebtService.waive(this.debtId, { reason: r });
        this.$emit('waived');
        this.$bvToast?.toast?.('Đã miễn nợ thành công', {
          variant: 'success',
          title: 'Thành công',
          autoHideDelay: 4000,
        });
        this.show = false;
      } catch (e) {
        const msg =
          e?.response?.data?.message || e?.message || 'Lỗi không xác định';
        this.reasonError = msg;
        // eslint-disable-next-line no-console
        console.error('[WaiveDebtDialog] waive error:', e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
